import { MatchResponse } from '../dto/response/match.response';
import { MatchFlowFinishedWebsocketDto } from '../dto/socket/match-flow-finished.socket';

export const matchFlowFinishedWebsocketListeners = (
  socketPayload: MatchFlowFinishedWebsocketDto,
  cachePositionId: string,
  updateCachedData: (args: (data: PaginationResponse<MatchResponse[]>) => void) => void,
): void => {
  updateCachedData((data: PaginationResponse<MatchResponse[]>) => {
    const { pendingReviewMatches, positionId } = socketPayload;

    if (positionId === cachePositionId) {
      data.results = pendingReviewMatches;
    }
  });
};
